import { render, staticRenderFns } from "./LoanStatusAlertContainer.vue?vue&type=template&id=48599e2a&scoped=true"
import script from "./LoanStatusAlertContainer.vue?vue&type=script&lang=js"
export * from "./LoanStatusAlertContainer.vue?vue&type=script&lang=js"
import style0 from "./LoanStatusAlertContainer.vue?vue&type=style&index=0&id=48599e2a&prod&lang=css"
import style1 from "./LoanStatusAlertContainer.vue?vue&type=style&index=1&id=48599e2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48599e2a",
  null
  
)

export default component.exports